package com.yendo.mx.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.isSystemInDarkTheme // 🚀 IMPORTANTE PARA EL DARK MODE
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.LocationOn
import androidx.compose.material.icons.filled.Person
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.yendo.mx.ui.theme.RosaYendo
import com.yendo.mx.ui.theme.YendoGradient
import com.yendo.mx.utils.formatPrecio // 🚀 IMPORTAMOS NUESTRO FORMATEADOR DE DINERO

@Composable
fun HeaderYendo(ubicacion: String, alTocarUbicacion: () -> Unit, alTocarPerfil: () -> Unit) {
    // 🚀 DETECTAMOS EL TEMA DEL SISTEMA
    val isDark = isSystemInDarkTheme()

    // 🚀 DEFINIMOS LOS COLORES DINÁMICOS
    val colorTextoPrincipal = if (isDark) Color.White else Color.DarkGray
    val colorTextoSecundario = if (isDark) Color(0xFFAAAAAA) else Color.Gray
    val colorFondoBoton = if (isDark) Color(0xFF2C2C2E) else Color.White
    val colorBordeBoton = if (isDark) Color(0xFF3A3A3C) else Color(0xFFEEEEEE)

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 12.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        // Lado izquierdo: Ubicación
        Row(
            modifier = Modifier
                .weight(1f)
                .clickable { alTocarUbicacion() },
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(Icons.Default.LocationOn, null, tint = RosaYendo, modifier = Modifier.size(20.dp))
            Spacer(modifier = Modifier.width(6.dp))
            Column {
                Text("Entregar en", fontSize = 10.sp, color = colorTextoSecundario)
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text(
                        ubicacion,
                        fontWeight = FontWeight.Bold,
                        fontSize = 14.sp,
                        color = colorTextoPrincipal, // 🚀 APLICADO AQUÍ
                        maxLines = 1
                    )
                    Icon(Icons.Default.KeyboardArrowDown, null, tint = colorTextoSecundario, modifier = Modifier.size(16.dp))
                }
            }
        }

        // Lado derecho: Botón de Perfil
        IconButton(
            onClick = alTocarPerfil,
            modifier = Modifier
                .size(40.dp)
                .background(colorFondoBoton, RoundedCornerShape(12.dp)) // 🚀 APLICADO AQUÍ
                .border(1.dp, colorBordeBoton, RoundedCornerShape(12.dp)) // 🚀 APLICADO AQUÍ
        ) {
            Icon(Icons.Default.Person, contentDescription = "Perfil", tint = colorTextoSecundario)
        }
    }
}

@Composable
fun BannersPublicidad() {
    val promos = listOf("Envío Gratis", "2x1 Tacos", "Promo Tiendita")

    LazyRow(
        contentPadding = PaddingValues(horizontal = 16.dp),
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        modifier = Modifier.padding(vertical = 12.dp)
    ) {
        items(promos) { promo ->
            Card(
                modifier = Modifier.width(280.dp).height(140.dp),
                shape = RoundedCornerShape(16.dp)
            ) {
                // El gradiente y texto blanco se ven bien en ambos modos, no hace falta cambiarlos.
                Box(modifier = Modifier.fillMaxSize().background(YendoGradient), Alignment.Center) {
                    Text(promo, color = Color.White, fontWeight = FontWeight.ExtraBold, fontSize = 20.sp)
                }
            }
        }
    }
}

@Composable
fun PantallaGenerica(titulo: String, icono: ImageVector) {
    val isDark = isSystemInDarkTheme()
    val colorIcono = if (isDark) Color.DarkGray else Color.LightGray
    val colorTexto = if (isDark) Color(0xFFAAAAAA) else Color.Gray

    Box(Modifier.fillMaxSize(), Alignment.Center) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Icon(icono, null, Modifier.size(60.dp), tint = colorIcono)
            Spacer(modifier = Modifier.height(16.dp))
            Text(titulo, color = colorTexto, fontWeight = FontWeight.Bold)
        }
    }
}

@Composable
fun BotonCarritoFlotante(onClick: () -> Unit) {
    val cantidad = com.yendo.mx.models.CartManager.totalArticulosBadge
    val total = com.yendo.mx.models.CartManager.totalDinero

    // Este botón al ser de un color primario (RosaYendo) con texto blanco,
    // tiene un contraste perfecto tanto en Light Mode como en Dark Mode.
    if (cantidad > 0) {
        Button(
            onClick = onClick,
            modifier = Modifier
                .fillMaxWidth()
                .navigationBarsPadding() // 🚀 EVITA QUE EL HOME INDICATOR LO TAPE EN IOS
                .padding(horizontal = 16.dp, vertical = 12.dp)
                .height(58.dp),
            colors = ButtonDefaults.buttonColors(containerColor = RosaYendo),
            shape = RoundedCornerShape(18.dp),
            elevation = ButtonDefaults.buttonElevation(defaultElevation = 8.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxSize(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Surface(
                    color = Color.White.copy(alpha = 0.25f),
                    shape = RoundedCornerShape(8.dp)
                ) {
                    Text(
                        text = cantidad.toString(),
                        color = Color.White,
                        fontWeight = FontWeight.ExtraBold,
                        modifier = Modifier.padding(horizontal = 10.dp, vertical = 2.dp),
                        fontSize = 16.sp
                    )
                }

                Text(
                    text = "Ver Carrito",
                    color = Color.White,
                    fontWeight = FontWeight.Bold,
                    fontSize = 16.sp
                )

                // 🚀 AQUÍ APLICAMOS EL FORMATO DE PRECIO PARA QUE SE VEA COMO $120.00
                Text(
                    text = "$${formatPrecio(total)}",
                    color = Color.White,
                    fontWeight = FontWeight.ExtraBold,
                    fontSize = 16.sp
                )
            }
        }
    }
}